import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Blog API
export const blogAPI = {
  // Get all blog posts
  getAllPosts: async (params = {}) => {
    try {
      const response = await axios.get(`${API}/blog/posts`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  // Get blog post by slug
  getPostBySlug: async (slug) => {
    try {
      const response = await axios.get(`${API}/blog/posts/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching blog post ${slug}:`, error);
      throw error;
    }
  },

  // Create blog post
  createPost: async (postData) => {
    try {
      const response = await axios.post(`${API}/blog/posts`, postData);
      return response.data;
    } catch (error) {
      console.error('Error creating blog post:', error);
      throw error;
    }
  },

  // Update blog post
  updatePost: async (postId, postData) => {
    try {
      const response = await axios.put(`${API}/blog/posts/${postId}`, postData);
      return response.data;
    } catch (error) {
      console.error(`Error updating blog post ${postId}:`, error);
      throw error;
    }
  },

  // Delete blog post
  deletePost: async (postId) => {
    try {
      const response = await axios.delete(`${API}/blog/posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting blog post ${postId}:`, error);
      throw error;
    }
  },

  // Get categories
  getCategories: async () => {
    try {
      const response = await axios.get(`${API}/blog/categories`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }
};

// Contact API
export const contactAPI = {
  // Submit contact form
  submitForm: async (formData) => {
    try {
      const response = await axios.post(`${API}/contact/submit`, formData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  },

  // Get all submissions (admin)
  getAllSubmissions: async (params = {}) => {
    try {
      const response = await axios.get(`${API}/contact/submissions`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching contact submissions:', error);
      throw error;
    }
  }
};

// Health check
export const healthCheck = async () => {
  try {
    const response = await axios.get(`${API}/health`);
    return response.data;
  } catch (error) {
    console.error('Health check failed:', error);
    throw error;
  }
};
